import Vue from 'vue'
// import Card from './Card'
import Child from './Child'
import CreateUpdateUserDialog from './CreateUpdateUserDialog'
// import Button from './Button'
// import Checkbox from './Checkbox'
// import { HasError, AlertError, AlertSuccess } from 'vForm'

// Components that are registered globaly.
const components = {
	// Card,
	Child,
	CreateUpdateUserDialog
	// Button,
	// Checkbox,
	// HasError,
	// AlertError,
	// AlertSuccess
}

for (let key in components) {
	Vue.component(components[key].name, components[key])
}
